import React, { useState, useEffect } from "react";
import Logo from "../assets/image/jas-logo-wb.png";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import { message } from "antd";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Spinner } from "react-bootstrap";
import Footer from "../components/superAdmin/footer/Footer";

function CommonLogin({ header, afterLogin, loginFailed, prem_name }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      handleChange();
    }
  };
  useEffect(() => {
    const token = localStorage.getItem("jff_token");
    if (token && token !== "undefined") {
      axios
        .get(
          `${process.env.REACT_APP_API_END_POINT}/check-authenticity/${token}`
        )
        .then((resData) => {
          if (
            resData.data.status &&
            resData.data.permission_names.includes(prem_name)
          ) {
            navigate(afterLogin);
          } else {
            navigate(loginFailed);
          }
        });
    } else {
      localStorage.removeItem("jff_token");
    }
  }, []);

  const handleChange = () => {
    setIsLoading(true);
    if (!email) {
      message.error("Enter username or email");
      setIsLoading(false);
      return;
    }
    if (!password) {
      message.error("Enter password");
      setIsLoading(false);
      return;
    } else {
      axios
        .post(`${process.env.REACT_APP_API_END_POINT}/login`, {
          email,
          password,
          login_type: prem_name,
        })
        .then((response) => {
          // If login was denied (no token returned), show error and stop
          if (!response.data.token) {
            setIsLoading(false);
            message.error(response.data.message || "Invalid credentials");
            return;
          }

          localStorage.setItem("jff_token", response.data.token);
          
          // Handle SubAdmin Role
          if (response.data.user && response.data.user.role === 'subadmin') {
            localStorage.setItem("role", "subadmin");
            localStorage.setItem("user_id", response.data.user.id);
            localStorage.setItem("permissions", JSON.stringify(response.data.user.permissions));
            setIsLoading(false);
            navigate("/subadmin/dashboard");
            return;
          }

          // Handle Existing Roles (SuperAdmin, Exhibitor, etc.)
          if (response.data.category && response.data.category.permissions) {
            localStorage.setItem(
              "permission",
              JSON.stringify(response.data.category.permissions)
            );
            localStorage.setItem("user_id", response.data.category._id);
            localStorage.setItem("role", response.data.category.role || "user");
            
            let data = response.data.category.permissions;
            axios
              .post(
                `${process.env.REACT_APP_API_END_POINT}/get-permission-name`,
                {
                  permission: data,
                }
              )
            .then((res) => {
              setIsLoading(false);
              let nameArray = res.data.data;
              localStorage.setItem("permission_names", JSON.stringify(nameArray));

              if (nameArray.includes(prem_name)) {
                navigate(afterLogin);
              } else {
                message.error("Not Authorised");
              }
            })
            .catch((err) => {
              setIsLoading(false);
              message.error("An error occurred while fetching permissions");
            });
          } else {
            setIsLoading(false);
            message.error(response.data.message || "Invalid account data");
          }
        })
        .catch((error) => {
          setIsLoading(false);
          console.log(error);
          message.error("Login failed. Please check your credentials.");
        });
    }
  };

  return (
    <>
      <div className="container">
        <img
          src={Logo}
          alt="logo-img"
          className="my-1 mx-auto d-flex"
          style={{
            height: "230px",
            width: "230px",
            marginTop: "40px !important",
            background: "#b98b51",
            padding: "10px",
            borderRadius: "10px",
          }}
        />

        <div className="exhibitorlogin">
          <div className="exhibitorloginbody">
            <div className="fw-semi-bold fs-3">{header}</div>
            <Form className="my-4" onSubmit={(e) => e.preventDefault()}>
              <Form.Control
                type="username"
                id="inputUsename"
                aria-describedby="passwordHelpBlock"
                placeholder="Username"
                className="my-4"
                required
                onChange={(e) => setEmail(e.target.value)}
                onKeyDown={handleKeyDown}
              />

              <Form.Control
                type="password"
                id="inputPassword5"
                aria-describedby="passwordHelpBlock"
                placeholder="Password"
                required
                onChange={(e) => setPassword(e.target.value)}
                onKeyDown={handleKeyDown}
              />

              <Button className="my-4 btn-block" onClick={handleChange}>
                {isLoading ? <Spinner animation="border" size="sm" /> : "Login"}
              </Button>
            </Form>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default CommonLogin;
